import { createAction, handleActions } from 'redux-actions'

const setSettings = createAction('SCREENS/SETTINGS/SET_SETTINGS')

const defaultState = []

const reducer = handleActions(
  {
    [setSettings]: (state, action) => {
      // Ensure we always return a valid array
      return Array.isArray(action.payload) ? action.payload : [];
    },
  },
  defaultState,
)

export { setSettings, reducer }
